const PaginaNaoEncontrada = () => {
  return (
    <>
      <h1>PaginaNaoEncontrada</h1>
    </>
  );
};

export default PaginaNaoEncontrada;
